import React from 'react'
import Navbar from '../Navbar'

import styles from './styles/OurTeam.module.css'

function OurTeam() {
  return (
    <div className='container'>
      <Navbar />
      <div className={styles.team}>
        <h1>Meet Team Skywalker</h1>
        <div className={styles.content}>
          <div className={styles.card}>
            <div className={styles.box}>
              <img
                className={styles.photo}
                src='../../Assets/SoumyaBanerjee1.jpg'
              />
              <div className={styles.info}>
                <div className={styles.name}>Soumya Banerjee</div>
                <div className={styles.details}>
                  FrontEnd Web Developer(React JS, Next Js, Firebase, HTML, CSS,
                  JS),Photographer
                </div>
                <div className={styles.sociallinks}>
                  <a
                    href='https://www.facebook.com/soumya.banerjee.796569/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-facebook-f' />
                  </a>
                  <a
                    href='https://www.linkedin.com/in/soumya-banerjee-94428a1a1/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-linkedin' />
                  </a>
                  <a
                    href='https://github.com/soumya495'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-github' />
                  </a>
                  <a
                    href='https://www.instagram.com/_soumya_banerjee/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <i className='fab fa-instagram' />
                  </a>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/kanchan1.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Kanchan Sarkar</div>
                  <div className={styles.details}>
                    Frontend-Developer(Html,CSS,JS,Ui/UX Designer),Writer
                  </div>
                  <div className={styles.sociallinks}>
                    <a
                      href='https://www.facebook.com/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-linkedin' />
                    </a>
                    <a
                      href='https://github.com/Kanchan-Sarkar'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://www.instagram.com/kanchan.sarkar.7370/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/Darshan1.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Darshan Bhandari</div>
                  <div className={styles.details}>
                    {' '}
                    Frontend-Web Developer(HTML, CSS, JS,Ui/UX Designer)
                  </div>
                  <div className={styles.sociallinks}>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a
                      href='https://www.linkedin.com/in/darshan-bhandari-128793241'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-linkedin' />
                    </a>
                    <a
                      href='https://github.com/DeveloperDarshan'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://instagram.com/darshanbhandari.exe?igshid=YmMyMTA2M2Y='
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/Simran1.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Simran Tiwary</div>
                  <div className={styles.details}>
                    {' '}
                    Web Developer(HTML,CSS,JS)
                  </div>
                  <div className={styles.sociallinks}>
                    <a
                      href='https://www.facebook.com/profile.php?id=100081142118006'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a
                      href='https://www.linkedin.com/in/simran-tiwary-377b55229'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-linkedin' />
                    </a>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://www.instagram.com/invites/contact/?i=1vi7z7yu4th83&utm_content=1ib2v69'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/Subinoy1.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Subinaya Mukherjee</div>
                  <div className={styles.details}>
                    Full-stack Web Developer(HTML, CSS, JS,Python)
                  </div>
                  <div className={styles.sociallinks}>
                    <a
                      href='https://www.facebook.com/profile.php?id=100014347036145'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a
                      href='https://www.linkedin.com/in/subinaya-mukherjee-73965a220'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-linkedin' />
                    </a>
                    <a
                      href='https://github.com/SubinoyMukherjee4148'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://www.instagram.com/invites/contact/?i=1vi7z7yu4th83&utm_content=1ib2v69'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img
                  className={styles.photo}
                  src='../../Assets/Srikanth1.jpg'
                />
                <div className={styles.info}>
                  <div className={styles.name}> J Srikanth Chetty</div>
                  <div className={styles.details}>
                    Developer(HTML, CSS, JS,DBMS)
                  </div>
                  <div className={styles.sociallinks}>
                    <a
                      href='https://www.facebook.com/janigam.srikanth'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-linkedin' />
                    </a>
                    <a
                      href='https://www.instagram.com/janigamsrikanth/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://www.instagram.com/janigamsrikanth/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/Rajdeep1.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Rajdeep Maji</div>
                  <div className={styles.details}>Web Developer(HTML, CSS)</div>
                  <div className={styles.sociallinks}>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a
                      href='https://www.linkedin.com/in/rajdeep-maji-7996ab236'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-linkedin' />
                    </a>
                    <a
                      href='https://github.com/Rajdeep-2002'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-github' />
                    </a>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.box}>
                <img className={styles.photo} src='../../Assets/Chanchal.jpg' />
                <div className={styles.info}>
                  <div className={styles.name}>Chanchal Mondal</div>
                  <div className={styles.details}>Developer(HTML,CSS)</div>
                  <div className={styles.sociallinks}>
                    <a
                      href='https://www.facebook.com/profile.php?id=100051217650284'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-facebook-f' />
                    </a>
                    <a
                      href='https://www.linkedin.com/in/chanchal-mondal-94517120b/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-linkedin' />
                    </a>
                    <a href='#' target='_blank' rel='noopener noreferrer'>
                      <i className='fab fa-github' />
                    </a>
                    <a
                      href='https://www.instagram.com/chanchal_mondal2562/'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <i className='fab fa-instagram' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurTeam
